export default __webpack_public_path__ + "static/media/validation-icon.0423452a.svg";